import React from 'react' // eslint-disable-line no-unused-vars
import Select from '../../forms/Select'
import { api } from '../index.api'
import { COUNTRIES } from '../../constants'
import { addNotification as notify } from 'reapop'
import connect from 'react-redux/es/connect/connect'
import { validateField } from '../../pages/functions'
import Footer from '../Footer'
import AdminNavigation from './AdminNavigation'
import ReactSelect from 'react-select'
import '../../css/forms/react-select/default.css'
import { withRouter } from "react-router-dom";

function onlyUnique (value, index, self) {
  return self.indexOf(value) === index
}

class AdminIndicationUpdate extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      productList: [],
      indicationMasterList: [],
      associatedIndicationNames: [],
      edit: false,
      fields: {
        affiliate: { name: 'affiliate', value: '', rules: { title: 'Affiliate', required: true } },
        product: { name: 'product', value: '', rules: { title: 'Product', required: true } }
      }
    }

    // formFieldsPerLanguage(this.state.fields, this.props.pageContent.content);
  }

    componentWillReceiveProps = nextProps => {
      // formFieldsPerLanguage(this.state.fields, nextProps.pageContent.content);
    }

    handleAffiliateChange = value => {
      const { fields } = this.state

      fields.product.errors = []
      fields.product.value = ''

      this.setState({
        fields,
        edit: false
      })

      if (value) {
        const queryParams = {
          affiliate: value
        }
        api.admin.indication.getProductIndicationMasterList(
          queryParams,
          this._getProductListSuccessHandler.bind(this),
          this._getProducListErrorHandler.bind(this)
        )
      }
    }

    _getProductListSuccessHandler = productIndicationMaster => {
      const productList = productIndicationMaster.PRODUCT_MASTER
      const indications = productIndicationMaster.INDICATION
      const indicationMasterList = indications.map(indication => {
        return {
          value: indication,
          label: indication
        }
      })

      this.setState({ productList, indicationMasterList, associatedIndicationNames: [] })
    }

    _getProducListErrorHandler = (error) => { /* eslint-disable-line */
      this._showNotification('Error', 'There seems to be some error while fetching data for selected affiliate.', 'error')
      this.setState({ productList: [], associatedIndicationNames: [] })
    }

    handleProductChange = value => {
      if (value) {
        const queryParams = {
          productId: value
        }

        api.admin.indication.getIndicationList(
          queryParams,
          this._getIndicationListSuccessHandler.bind(this),
          this._getIndicationListErrorHandler.bind(this)
        )
      }
    }

    _getIndicationListSuccessHandler = associatedIndicationList => {
      const associatedIndicationNames = associatedIndicationList.map(indication => indication.name)
      this.setState({ associatedIndicationNames, edit: false })
      this.lastUpdatedIndicationAssociation = associatedIndicationNames
    }

    _getIndicationListErrorHandler = (error) => { /* eslint-disable-line */
      this._showNotification('Error', 'There seems to be some error while fetching indications for selected product.', 'error')
    }

    _validate = (e, field) => {
      const fields = validateField(e, field, this.state.fields)
      this.setState({ fields })

      return false
    }

    handleSelectedChanged =selected => {
      const selectedIndicationNames = []
      selected.forEach(s => {
        selectedIndicationNames.push(s.value)
      })
      this.setState({ associatedIndicationNames: selectedIndicationNames })
    }

    handleEditClick = () => {
      this.setState({ edit: true })
    }

    handleCancelClick = () => {
      this.setState({
        edit: false,
        associatedIndicationNames: this.lastUpdatedIndicationAssociation
      })
    }

    handleSaveClick = e => {
      this.setState({ edit: false })

      const productIndicationAssociation = {
        productId: this.state.fields.product.value,
        indicationNames: this.state.associatedIndicationNames
      }

      api.admin.indication.updateIndicationAssociation(
        productIndicationAssociation,
        this._updateIndicationAssociationSuccessHandler.bind(this),
        this._updateIndicationAssociationErrorHandler.bind(this)
      )
    }

    _updateIndicationAssociationSuccessHandler = response => {
      if (response.status === 200) {
        this.lastUpdatedIndicationAssociation = this.state.associatedIndicationNames
        this._showNotification('Success', 'Indications updated successfully.', 'success')
        //creating the url
        const affiliate = this.state.fields.affiliate.value;
        const productId = this.state.fields.product.value;
        const url = `/admin/new-manage-indications?affiliate=${encodeURIComponent(affiliate)}&productId=${encodeURIComponent(productId)}`;
        setTimeout(() => this.props.history.push(url), 2000);
        
     } else if (response.status === 401) {
        this._showNotification('Error', 'You are not authorized to perform this action. Please log in again.', 'error')
        this.setState({ associatedIndicationNames: this.lastUpdatedIndicationAssociation })
        setTimeout(() => window.location.replace('/'), 3000)
      } else {
        this._showNotification('Error', 'There seems to be some error while updating indication association', 'error')
        this.setState({ associatedIndicationNames: this.lastUpdatedIndicationAssociation })
      }
    }

    _updateIndicationAssociationErrorHandler = (error) => { /* eslint-disable-line */
      this._showNotification('Error', 'There seems to be an error at our server side. Please try later.', 'error')
      this.setState({ associatedIndicationNames: this.lastUpdatedIndicationAssociation })
    }

    _showNotification = (title, message, status) => {
      const { notify } = this.props
      notify({
        title,
        message,
        status,
        position: 'tr',
        dismissible: true,
        dismissAfter: 6000
      })
    }

    render () {
      const languageContent = this.props.pageContent.content
      this.countryList = (this.props.referenceData.filter(function (item) {
        return (item.type === COUNTRIES)
      })[0]).countries
      this.affiliateList = this.countryList.map(c => c.affiliate)
      this.affiliateList = this.affiliateList.filter(onlyUnique).sort()
      this.affiliateOptions = this.affiliateList.map(function (affiliate) {
        return {
          value: affiliate,
          label: affiliate
        }
      })

      this.productListOptions = this.state.productList.map(product => {
        return {
          value: product.id,
          label: product.name
        }
      })

      return (
        <div className='page-container'>
          <div className='page-content'>
            <div className='v2_container'>
              <div className='row'>
                <AdminNavigation className='col-xl-2 col-lg-3 col-md-4 col-6' />
                <div className='col-xl-10 col-lg-9 col-md-8 col-6 p-l-15'>
                  <div className='row'>
                    <div className='col-12 col-xl-12'>
                      <h3 className='mb-3 header-primary'>{languageContent.module.admin.indication.heading}</h3>
                      <p>{languageContent.module.admin.indication.affiliateSelect}</p>
                    </div>
                  </div>
                  <div className='row  mb-4'>
                    <div className='col-md-4'>
                      <Select
                        searchable
                        clearable={false}
                        options={this.affiliateOptions}
                        field={this.state.fields.affiliate}
                        onChange={this.handleAffiliateChange}
                        validate={(e, field) => this._validate(e, this.state.fields.affiliate)}
                      />
                    </div>
                  </div>
                  <div className='row'>
                    <div className='col-12 col-xl-12'>
                      <p>{languageContent.module.admin.indication.productSelect}</p>
                    </div>
                  </div>
                  <div className='row  mb-5'>
                    <div className=' col-md-4'>
                      <Select
                        searchable
                        clearable={false}
                        options={this.productListOptions}
                        field={this.state.fields.product}
                        onChange={this.handleProductChange}
                        validate={(e, field) => this._validate(e, this.state.fields.product)}
                      />
                    </div>
                  </div>

                  {this.state.fields.product.value !== '' &&
                    <div>
                      <div className='row  mb-4'>
                        <div id='indication-multi-select' className='col-md-4 react-floating-label-select fli-container'>
                          <ReactSelect
                            multi
                            options={this.state.indicationMasterList}
                            onChange={this.handleSelectedChanged}
                            value={this.state.associatedIndicationNames}
                            placeholder='Select Indications ...'
                            disabled={!this.state.edit}
                          />
                        </div>
                      </div>
                      {this.state.edit
                        ? (
                          <div className='col-xl-12 mt-4 m-b-10 text-right'>
                            <button
                              onClick={this.handleCancelClick}
                              className='btn btn-primary btn-outline hover btn-lg btn-icon reset-button btn-rounded m-r-10'
                            >
                              <span>{languageContent.module.admin.indication.cancel}</span>
                            </button>
                            <button
                              onClick={this.handleSaveClick}
                              className='btn btn-info btn-lg-wide submit-button btn-icon btn-rounded'
                            >
                              <span>Save & Next</span>
                            </button>
                          </div>)
                        : (
                          <div className='col-xl-12 mt-4 m-b-10 text-right'>
                            <button
                              onClick={this.handleEditClick}
                              className='btn btn-info btn-lg-wide search-button btn-rounded'
                            >
                              <span>{languageContent.module.admin.indication.edit}</span>
                            </button>
                          </div>)}
                    </div>}
                </div>
              </div>
            </div>
          </div>
          <Footer />
        </div>
      )
    }
}

function mapStateToProps (state) {
  return {
    referenceData: state.referenceData,
    pageContent: state.pageContent
  }
}

export default withRouter(connect(mapStateToProps, { notify })(AdminIndicationUpdate));



// WEBPACK FOOTER //
// ./src/mi-app/adminPanel/AdminIndicationUpdate.js